import {CreateEditSystemAgent, SystemAgentDomain, UserId} from "platformed-client/types";
import {platformedClient} from ".";
import {invalidateQueries, q} from "../state";

export async function list(domain: SystemAgentDomain) {
  return await platformedClient.internalRequest("get", "/region/{region}/api/system_agents/domain/{domain}", {
    path: {domain},
  });
}

export async function listAll() {
  return await platformedClient.internalRequest("get", "/region/{region}/api/system_agents", {path: {}});
}

export async function listDefault() {
  return await platformedClient.internalRequest("get", "/region/{region}/api/system_agents/default", {path: {}});
}

export async function create(agent: CreateEditSystemAgent) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/system_agents", {
    path: {},
    body: agent,
  });
  await invalidateQueries([q.systemAgentsByDomain.filter(), q.systemAgents.filter()]);
  return res;
}
export async function update(agent: CreateEditSystemAgent, userId: UserId) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/system_agents/{user_id}", {
    path: {user_id: userId},
    body: agent,
  });
  await invalidateQueries([q.systemAgentsByDomain.filter(), q.systemAgents.filter()]);
  return res;
}

export async function delete_(userId: UserId) {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/system_agents/{user_id}", {
    path: {user_id: userId},
  });
  await invalidateQueries([q.systemAgentsByDomain.filter(), q.systemAgents.filter()]);
  return res;
}
